import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Kit Arranque en 10 Min',
    desc: 'Configura ChatGPT y DeepSeek como herramientas de trabajo reales y evita los 15 errores que hacen que la IA te dé basura.',
    value: '$47'
  }, {
    title: 'Biblioteca Prompts Universales',
    desc: '100 prompts listos para copiar, pegar y adaptar en ChatGPT, DeepSeek y similares. Organizados por objetivo. Funcionan desde el primer intento.',
    value: '$37'
  }, {
    title: 'Checklist Anti-Alucinaciones',
    desc: 'Detecta cuando la IA inventa cosas y convierte cualquier respuesta en algo confiable en menos de 5 minutos. Protocolo de 3 pasadas.',
    value: '$27'
  }, {
    title: 'Plantillas Correos Perfectos',
    desc: '25 situaciones reales con prompts maestros y ejemplos generados. Responde correos difíciles en 60 segundos con tono humano.',
    value: '$37'
  }, {
    title: 'Workbook 1 Hora / 10 Activos',
    desc: 'Convierte 1 idea en 10 piezas de contenido listas para publicar en 60 minutos. El sistema de reutilización que elimina el bloqueo creativo.',
    value: '$47'
  }, {
    title: 'Tracker Plan 30 Días IA',
    desc: 'Rutina diaria de 10-15 minutos durante 30 días para convertir la IA en un hábito real. Con scorecard semanal y backlog de tareas.',
    value: '$27'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-background to-surface/50" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-19">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <div className="inline-block bg-brand/10 text-brand font-bold px-6 py-2 rounded-full border border-brand/20" data-id="element-20">
            SIEMPRE INCLUIDOS
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-21">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-surface border border-border rounded-2xl p-6 relative overflow-hidden group hover:border-brand/50 transition-colors" data-id="element-22">
              <div className="absolute -right-6 -top-6 text-brand/5 group-hover:text-brand/10 transition-colors" data-id="element-23">
                <Gift size={120} data-id="element-24" />
              </div>
              <div className="relative z-10" data-id="element-25">
                <div className="text-brand font-bold mb-2" data-id="element-26">BONO {idx + 1}</div>
                <h3 className="text-xl font-heading font-bold text-white mb-3" data-id="element-27">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 mb-6 min-h-[80px] text-sm" data-id="element-28">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-3 font-bold" data-id="element-29">
                  <span className="text-danger line-through" data-id="element-30">
                    {bonus.value}
                  </span>
                  <span className="text-brand text-xl" data-id="element-31">→ GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-surface border-2 border-brand/30 rounded-2xl p-6 text-center max-w-2xl mx-auto" data-id="element-32">
          <div className="text-xl md:text-2xl font-bold flex items-center justify-center gap-2 flex-wrap" data-id="element-33">
            <span className="text-white" data-id="element-34">Valor total bonos </span>
            <span className="text-danger line-through mx-2" data-id="element-35">$222</span>
            <span className="text-brand" data-id="element-36">→ GRATIS con tu MegaPack ✅</span>
          </div>
        </motion.div>
      </div>
    </section>;
}